import { z } from 'zod'

export const MEMBERSHIP_ME_PROFILE_WRITE_CONTRACT_VERSION = '1.0.1' as const

const nullableDate = z.string().refine((value) => Number.isFinite(Date.parse(value)), 'Invalid datetime').nullable()

const provenanceSchema = z.object({
  sourceSystem: z.string(),
  sourceTable: z.string(),
  sourceRecordId: z.string(),
  migrationStatus: z.string(),
  lastSyncedAt: nullableDate,
  readiness: z.string(),
  canRefresh: z.boolean(),
  providerTouched: z.boolean(),
}).passthrough()

const profileSchema = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  displayName: z.string(),
  isAdmin: z.boolean(),
  sessionVersion: z.number().int().nullable(),
  status: z.string(),
  joinedAt: nullableDate,
  updatedAt: nullableDate,
  provenance: provenanceSchema,
}).passthrough()

/** Request schemas serve clients/tests; body validation stays in the handler. */
export const membershipMeProfileUpdateRequestSchema = z.object({
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  displayName: z.string().nullable().optional(),
}).passthrough()

export const membershipMeProfileUpdateResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_ME_PROFILE_WRITE_CONTRACT_VERSION),
  ok: z.literal(true),
  profile: profileSchema,
}).passthrough()

export type MembershipMeProfileUpdateRequest = z.infer<typeof membershipMeProfileUpdateRequestSchema>
export type MembershipMeProfileUpdateResponse = z.infer<typeof membershipMeProfileUpdateResponseSchema>
